import { useParams } from "react-router-dom";
import AdForm from "../components/ads/AdForm";

function AdsPage() {
  const { id } = useParams(); // Get the ID from the URL
  return (
    <div className="page p-1">
      <AdForm id={id} />
    </div>
  );
}

export default AdsPage;
